import history from '../history';
import * as URLs from '../constants/systemUrls';

export const redirectMiddleware = store => next => action => {
  const url = window.location.pathname;
  const loginStatus = store.getState().Authorization.status.loginStatus;

  if (action.type === 'SET_ACTIVE_PROFILE') {
    const { payload } = action;
    if (payload.redirect) {
      history.push('/' + URLs.CONTROL_PANEL);
    }
  } else if (action.type === 'UNSET_ACTIVE_PROFILE') {
    history.push('/' + URLs.AUTHORIZATION + '/' + URLs.PROFILES_LIST);
  }

  if (url === '/check_code') {
    history.push('/authorization/login');
  }

  if (loginStatus.message === 'FAILURE') {
    history.push('/authorization/login');
  } else if (
    (url === '/authorization/login' || url === '/') &&
    loginStatus.message === 'SUCCESS'
  ) {
    history.push('/authorization/profiles');
  }

  return next(action);
};
